import AdminOrderList from './AdminOrderList';
export default AdminOrderList;
